<template>
  <div
    class="collapsible-example border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden"
  >
    <button
      class="w-full flex justify-between items-center p-2 bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-left"
      @click="isOpen = !isOpen"
    >
      <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{
        title
      }}</span>
      <Icon
        :path="isOpen ? mdiChevronUp : mdiChevronDown"
        class="w-4 h-4 text-gray-500 dark:text-gray-400"
      />
    </button>
    <div v-show="isOpen" class="p-2 bg-white dark:bg-gray-800">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import Icon from "@/components/Icon.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
});

const isOpen = ref(false);
</script>
